export const roles = {
  PM: "PM",
  SALE: "SALE",
  ADMIN: "ADMIN",
  SUPERADMIN: "SUPER-ADMIN",
  EXTERN: "EXTERN",
  ALL: "ALL",
};
